// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__jIIgZ","rootSuccess":"CompleteLink_rootSuccess__1l-BY","rootFailure":"CompleteLink_rootFailure__3uFB1","isDisabled":"CompleteLink_isDisabled__tj3Ps"};